import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangelogsComponent} from './changelogs.component';
import {SharedModule} from '../shared/shared.module';
import {CoreModule} from '../core/core.module';

import {PanelModule} from "primeng/panel";
import {MarkdownModule} from "ngx-markdown";
import {ChangelogsRoutingModule} from "./changelogs-routing.module";
import {ChangelogsDropMenuComponent} from "./changelogs-drop-menu/changelogs-drop-menu.component";
import {ChangelogsDetailsComponent} from "./changelogs-details/changelogs-details.component";


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,

    PanelModule,
    MarkdownModule,
    ChangelogsRoutingModule
  ],
  declarations: [
    ChangelogsComponent,
    ChangelogsDropMenuComponent,
    ChangelogsDetailsComponent
  ],
  exports: [ChangelogsComponent]
})
export class ChangelogsModule { }
